module.exports = __webpack_public_path__ + "img/bannerButtonImage.e54fe2a4.png";